import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

const getDefaultSelectedMainUnit = () => {
  return {};
};

export default {
  state: () => ({
    selectedMainUnit: getDefaultSelectedMainUnit(),
    mainUnits: [],
    isCameToStation: false,
    isCameToAgency: false,
    selectedPresetUnit: null,
  }),

  mutations: {
    setSelectedMainUnit(state, mainUnit) {
      Vue.set(state, "selectedMainUnit", mainUnit);
    },
    setMainUnits(state, mainUnits) {
      Vue.set(state, "mainUnits", mainUnits);
    },
    setIsCameToStation(state, isCameToStation) {
      Vue.set(state, "isCameToStation", isCameToStation);
    },
    setIsCameToAgency(state, isCameToAgency) {
      Vue.set(state, "isCameToAgency", isCameToAgency);
    },
    setSelectedPresetUnit(state, selectedPresetUnit) {
      Vue.set(state, "selectedPresetUnit", selectedPresetUnit);
    },
    setDefaultSelectedMainUnit(state) {
      Vue.set(state, "selectedMainUnit", getDefaultSelectedMainUnit());
    },
    setDefaultMainUnitModule(state) {
      Vue.set(state, "selectedMainUnit", getDefaultSelectedMainUnit());
      Vue.set(state, "mainUnits", []);
      Vue.set(state, "isCameToStation", false);
      Vue.set(state, "isCameToAgency", false);
      Vue.set(state, "selectedPresetUnit", null);
    },
  },

  actions: {
    //TODO: load, update, create
    createMainUnit: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/units/entity", request, {})
        .then((response) => {
          // context.commit("setSelectedMainUnit", response.data);
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadMainUnits: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/entity").then((response) => {
        context.commit("setMainUnits", response.data);
        return response.data;
      });
    },
    loadPublishedMainUnits: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/entity/published").then((response) => {
        return response.data;
      });
    },
    loadMainUnit: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/entity/" + request.id).then((response) => {
        context.commit("setSelectedMainUnit", response.data);
        return response;
      });
    },
    loadUnitTree: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/get-complete-unit-tree").then((response) => {
        return response.data;
      });
    },
    loadSelectedMainUnitHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    loadGetPartialUnitTree: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/get-partial-unit-tree/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    loadGetPartialUnitTreeOnlyAgencies: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/agency-get-partial-unit-tree/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteMainUnit: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/units/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftMainUnit: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/units/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    recallMainUnit: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/recall/" + mainUnit.intentId).then((response) => {
        return response.data;
      });
    },
    cancelMainUnit: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/cancel/" + mainUnit.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalMainUnit: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/sendToApproval/" + mainUnit.intentId).then((response) => {
        if (mainUnit.intents[0].type === "CREATE_MAIN_UNIT") {
          mainUnit.intents[0].status = "WAITING_APPROVAL";
        } else if (mainUnit.intents[0].type === "UPDATE_MAIN_UNIT") {
          mainUnit.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    publishMainUnit: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/publish/" + mainUnit.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectMainUnit: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/reject/" + mainUnit.intentId).then((response) => {
        if (mainUnit.intents[0].type === "DELETE_MAIN_UNIT") {
          mainUnit.intents = null;
          mainUnit.intentId = 0;
        } else if (mainUnit.intents[0].type === "CREATE_MAIN_UNIT") {
          mainUnit.intents[0].status = "DRAFT";
        } else if (mainUnit.intents[0].type === "UPDATE_MAIN_UNIT") {
          mainUnit.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    loadUnitsGetPartialUnitTree: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/get-partial-unit-tree/" + request.id).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedMainUnit: (state) => {
      return state.selectedMainUnit;
    },
    getMainUnits: (state) => {
      return state.mainUnits;
    },
    getIsCameToStation: (state) => {
      return state.isCameToStation;
    },
    getIsCameToAgency: (state) => {
      return state.isCameToAgency;
    },
    getSelectedPresetUnit: (state) => {
      return state.selectedPresetUnit;
    },
  },
};
